import { Image, Layer, Rect } from 'react-konva';

import brk0Img from "./assets/brk0.png";
import brk1Img from "./assets/brk1.png";
import brk2Img from "./assets/brk2.png";
import brk3Img from "./assets/brk3.png";
import useImage from 'use-image';
import { useRef, useState } from 'react';

type BreakLayerProps = {
    allow: boolean;
    point: { x: number; y: number };
    startBroken?: boolean;
    onBreak?: () => void;
};

const WIDTH = 2388;
const HEIGHT = 1668;

export function BreakLayer({ allow, point, startBroken = false, onBreak }: BreakLayerProps) {
    const [breakStarted, setBreakStarted] = useState(false);
    const [isBroken, setIsBroken] = useState(startBroken);
    const [breakingPoint, setBreakingPoint] = useState(isBroken ? 2 : 0);
    const measuredTotalClicks = useRef(0);

    const [brk0] = useImage(brk0Img);
    const [brk1] = useImage(brk1Img);
    const [brk2] = useImage(brk2Img);
    const [brk3] = useImage(brk3Img);

    const imgs = [brk0, brk1, brk2, brk3];


    const handleClick = (e: any) => {
        console.log("click", e);
        if (allow && !isBroken) {
            console.log("click allowed");
            setBreakStarted(true);

            measuredTotalClicks.current++;
            if (measuredTotalClicks.current >= 5) {
                setBreakingPoint((prev) => prev + 1);
                measuredTotalClicks.current = 0;

                if (breakingPoint >= imgs.length - 2) {
                    setIsBroken(true);
                    setBreakStarted(false);
                    measuredTotalClicks.current = 0;
                    onBreak?.();
                }
            }

        }
    };

    return <Layer
        listening={!isBroken}
    >
        <Rect
            listening={!isBroken}
            x={0}
            y={0}
            width={window.innerWidth}
            height={window.innerHeight}
            fill="transparent"
            opacity={allow ? 0 : 1}
            onClick={handleClick}
            onTap={handleClick}
        />
        <Image
            listening={!isBroken}
            // visible={!breakStarted || isBroken}
            image={imgs[breakingPoint % imgs.length]}
            x={point.x}
            y={point.y}
            width={WIDTH}
            height={HEIGHT}
            offsetX={WIDTH / 2}
            offsetY={HEIGHT / 2}
            onClick={handleClick}
            onTap={handleClick}
            scale={{ x: 0.7, y: 0.7 }}
        />
    </Layer>
};
